
// src/layouts/AppLayout.js
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AppLayout = ({
  children,
  isLoggedIn,
  setIsLoggedIn,
  handleLogout,
  onUpgradeClick,
}) => {
  return (
    <div className="bg-surface-50 min-h-screen w-full overflow-x-hidden flex flex-col">
      <Header
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        handleLogout={handleLogout}
        onUpgradeClick={onUpgradeClick}
      />
      <div className="flex-1">{children}</div>
      <Footer />
    </div>
  );
};

export default AppLayout;
